export const PAGE_SIZE = 10
export const API_ENDPOINT =
  'https://to45rgws05.execute-api.us-east-2.amazonaws.com/'
export const BUCKET =
  'https://myloveydove-s3uploadbucket-wehl1ofnm65a.s3.us-east-2.amazonaws.com'
